import { WORK_BADGE_REVIEW_POLICY_FULL_PATH } from "../../Documents/paths";
import { type WorkBadgeReviewPolicySource } from "../components/Policy/types";
import { type WorkBadgeReviewPolicyStep } from "../hooks/useWorkBadgeReviewPolicy";

interface GetWorkBadgeReviewPolicyUrlParams {
  source: WorkBadgeReviewPolicySource;
  shiftId: string;
  qualificationName: string;
  step: WorkBadgeReviewPolicyStep;
  fromBadgeIntro?: boolean;
}

export function getWorkBadgeReviewPolicyUrl(params: GetWorkBadgeReviewPolicyUrlParams): string {
  const { source, shiftId, qualificationName, step, fromBadgeIntro } = params;

  const searchParams = new URLSearchParams({
    source,
    shiftId,
    qualificationName,
    step,
    ...(fromBadgeIntro ? { fromBadgeIntro: "true" } : {}),
  });

  return `${WORK_BADGE_REVIEW_POLICY_FULL_PATH}?${searchParams.toString()}`;
}
